import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchSalesOrderRequisitionConfigs,
  fetchSalesOrderRequisitionConfigById,
  addSalesOrderRequisitionConfig,
  updateSalesOrderRequisitionConfig,
  removeSalesOrderRequisitionConfig,
} from "../../api/salesOrderRequisitionConfigApi";

export const getSalesOrderRequisitionConfigs = createAsyncThunk(
  "salesOrderRequisitionConfig/getSalesOrderRequisitionConfigs",
  async (_, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await fetchSalesOrderRequisitionConfigs();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSalesOrderRequisitionConfigById = createAsyncThunk(
  "salesOrderRequisitionConfig/getSalesOrderRequisitionConfigById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await fetchSalesOrderRequisitionConfigById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createSalesOrderRequisitionConfig = createAsyncThunk(
  "salesOrderRequisitionConfig/createSalesOrderRequisitionConfig",
  async (data: any, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await addSalesOrderRequisitionConfig(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editSalesOrderRequisitionConfig = createAsyncThunk(
  "salesOrderRequisitionConfig/editSalesOrderRequisitionConfig",
  async (
    { id, data }: { id: string; data: any },
    { dispatch, rejectWithValue }
  ) => {
    dispatch(resetStatus());
    try {
      return await updateSalesOrderRequisitionConfig(id, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSalesOrderRequisitionConfig = createAsyncThunk(
  "salesOrderRequisitionConfig/deleteSalesOrderRequisitionConfig",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());
    try {
      return await removeSalesOrderRequisitionConfig(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const salesOrderRequisitionConfigSlice = createSlice({
  name: "salesOrderRequisitionConfig",
  initialState: {
    configs: [] as any[],
    config: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getSalesOrderRequisitionConfigs.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.configs = action.payload?.data || [];
        }
      )
      .addCase(getSalesOrderRequisitionConfigs.rejected, (state, action) => {
        state.status = false;
        state.configs = [];
        state.error = action.payload as string;
      })
      .addCase(
        getSalesOrderRequisitionConfigById.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = true;
          state.config = action.payload?.data;
        }
      )
      .addCase(getSalesOrderRequisitionConfigById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(
        createSalesOrderRequisitionConfig.fulfilled,
        (state) => {
          state.status = true;
          state.msg = "Sales Order Requisition Configuration created successfully.";
        }
      )
      .addCase(createSalesOrderRequisitionConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(editSalesOrderRequisitionConfig.fulfilled, (state) => {
        state.status = true;
        state.msg = "Sales Order Requisition Configuration updated successfully.";
      })
      .addCase(editSalesOrderRequisitionConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(
        deleteSalesOrderRequisitionConfig.fulfilled,
        (state) => {
          state.status = true;
          state.msg = "Sales Order Requisition Configuration deleted successfully.";
        }
      )
      .addCase(deleteSalesOrderRequisitionConfig.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetStatus } = salesOrderRequisitionConfigSlice.actions;
export default salesOrderRequisitionConfigSlice.reducer;
